import React, { Component } from 'react';

class Bachelor extends Component {
  render() {
    if(this.props.data){
      var overview = this.props.data.overview;
      var thesis = this.props.data.thesis;
      var publication = this.props.data.publication;
      var FedCSIS = this.props.data.FedCSIS;
    }
      return(
          <section id = "bachelor">
           <div className="row">
                  <div className="twelve columns collapsed">
                        <h1><span>{this.props.isGerman ? "Mein Bachelorprojekt" : "My Bachelor Project"}</span></h1>
                    </div>
                    <div id="work-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                      <div>
                        <h3>{this.props.isGerman ? "Schneller Überblick" : "Quick Overview"}</h3>
                          <p className="info">
                              {overview}
                          </p>
                      </div>
                        <br/>
                        <br/>
                      <div>
                        <h3>{this.props.isGerman ? "Bachelorarbeit und Publikation" : " Thesis and Publication"} </h3>
                          <p className="info">
                              {thesis}
                          </p>
                          <p className="info">
                                {publication} <h4 style={{textAlign: 'center'}}><a target="_blank" rel="noopener noreferrer" href="https://ieeexplore.ieee.org/document/8859827">Robust Image Forgery Detection Using Point Feature Analysis</a></h4>
                            </p>
                      </div>
                      <br/>
                      <div>
                        <h3>FedCSIS Leipzig,2019</h3><h4 style={{textAlign: 'center'}}><a target="_blank" rel="noopener noreferrer" href="https://fedcsis.org/">FedCSIS</a></h4>

                          <p className="info">
                                {FedCSIS}
                          </p>
                      </div>
                  </div>
                </div>
          </section>
      );
  }
}
  export default Bachelor;